import React, { useContext } from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import MetadataIcon from 'assets/icons/metadataGlyph24'
import ClockIcon from 'assets/icons/clock'
import InitiativeGroupIcon from 'assets/icons/initiativeGroup'
import LocationIcon from 'assets/icons/location'
import PrivacyIcon from 'assets/icons/privacy'
import initiativePrivacyConstants from 'config/constants/initiativePrivacy'
import { initiativeEventsUrl } from 'config/constants/urls'
import { useOrganization } from 'src/core/graphql/hooks'
import { InitiativeHierarchyContext } from 'src/sites/kits/Utils/InitiativeHierarchy'

const DetailsBlockRow = ({ body, icon }) => (
   <View
      width="100%"
      display="flex"
      padding="5px[a-d] 10px 0px[e-f]"
      alignItems="center">
      <View
         width="20px"
         height="20px"
         flex="0 0 auto"
         display="flex"
         justifyContent="center"
         alignItems="center"
         marginRight="25px">
         {icon}
      </View>
      <View flex="1 1 auto">
         <Text
            color="#666"
            size="2"
            lineHeight="150%"
            style={{ letterSpacing: '-0.1px' }}
            weight="normal">
            {body}
         </Text>
      </View>
   </View>
)

DetailsBlockRow.propTypes = {
   body: PropTypes.node.isRequired,
   icon: PropTypes.node.isRequired
}

const EventDetailsBlock = ({ showLocation }) => {
   const { organization } = useOrganization()
   const { initiative } = useContext(InitiativeHierarchyContext)

   // TODO: Refactor how we use ancestor data. See: #862
   const parentInitiative = initiative.ancestors[0]
   const privacyDescription = initiativePrivacyConstants
      .find(p => p.value === initiative.privacy)
      .description(initiative, organization)

   return (
      <View width="100%" marginBottom="20px[a-b] 40px[c-f]">
         {parentInitiative && parentInitiative.type.class === 'group' && (
            <DetailsBlockRow
               body={(
                  <Link to={initiativeEventsUrl(parentInitiative)}>
                     <Text size="2" color="#888">
                        <u>{parentInitiative.name}</u>
                     </Text>
                  </Link>
               )}
               icon={(<InitiativeGroupIcon color="#666" width="16px" height="16px" />)}
            />
         )}
         {initiative.eventIsVirtual && (
            <DetailsBlockRow
               body="This is an online event only"
               icon={(<MetadataIcon color="#666" width="16px" height="16px" />)}
            />
         )}
         <DetailsBlockRow
            body={(
               <>
                  {initiative.startDateTime
                     ? initiative.startDateTime
                     : 'Date and time has not yet been set'
                  }
                  {initiative.endDateTime && ` to ${initiative.endDateTime}`}
               </>
            )}
            icon={(<ClockIcon color="#666" width="16px" height="16px" />)}
         />
         {!initiative.eventIsVirtual &&
         showLocation &&
         initiative.location.formattedAddress && (
            <DetailsBlockRow
               body={(
                  <>
                     {initiative.location.formattedAddress}
                     &nbsp;
                     <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(initiative.location.formattedAddress)}`}>
                        <Text size="2" color="#888">
                           <u>View Map</u>
                        </Text>
                     </a>
                  </>
               )}
               icon={(<LocationIcon color="#666" width="18px" height="18px" />)}
            />
         )}
         {/* This is for Sessions */}
         {initiative.ancestors.length > 0 && initiative.location.name && (
            <DetailsBlockRow
               body={initiative.location.name}
               icon={(<LocationIcon color="#666" width="18px" height="18px" />)}
            />
         )}
         {initiative.ancestors.length === 0 && (
            <DetailsBlockRow
               body={privacyDescription}
               icon={(<PrivacyIcon color="#666" width="18px" height="18px" />)}
            />
         )}
      </View>
   )
}

EventDetailsBlock.propTypes = {
   showLocation: PropTypes.bool
}

EventDetailsBlock.defaultProps = {
   showLocation: true
}

export default EventDetailsBlock
